import { makeObservable } from "mobx";
import { RouteDef } from "../@types";

export const makeObservableRouteDef = <T extends RouteDef>(routeDef: T) => makeObservable(routeDef, { component: false });